import { ITab } from '../../../shared/Tabs/tabs.types.ts'
import { TMaintenanceCardTab } from './maintenance.types.ts'

const cardTabs: ITab<TMaintenanceCardTab>[] = [
  { title: 'Модели ТО', id: 'processes' },
  { title: 'Бланки', id: 'blanks' },
]

const maintenancePageConstants = { cardTabs }
export default maintenancePageConstants
